import { Button, Form, message, Input, Col, Row } from 'antd';
import AppHeader from 'components/AppHeader';
import React, { useState, useEffect } from 'react';
import statisticApis from 'api/statisticApis';
import { ContentRow } from 'components/ThemeComponents';
import { StyledTable, OFFSET_HEADER } from 'components/ThemeComponents';
import { fullDateTimeFormat } from 'helpers/dateTimeHelper';

export default function OrderPaymentStatisticsPage() {

  const [statistics, setStatistics] = useState([]);

  async function fetchOrderPaymentsInfo(params={}) {
    try {
      const res = await statisticApis.order_payments(params);
      setStatistics(res);
    } catch (error) {
      message.info(error.message);
    }
  }

  useEffect(() => {
    fetchOrderPaymentsInfo()
  }, []);

  
  
  return (
    <>
      <h1>OrderPayments Statistics</h1>
      <pre>{JSON.stringify(statistics, null, 2)}</pre>
    </>
  );
}
